import { attachRowDailyHistoryRunLinks } from '@/features/shared/components/entityDailyHistory/dailyHistoryLinks';
import { buildSuiteDetailPath } from '@/features/shared/components/tableSystem/tableRoutes';
import { resolveTestEntityDisplayName } from '@/features/shared/utils/testDisplayName';
import { resolveSuiteEntityDisplayName } from '@/features/suites/utils/suiteDisplayName';
import type { EntityDailyHistoryRow } from '@/features/shared/components/entityDailyHistory/EntityDailyHistoryPanel';
import type { TestDailyStatusDto } from '@flowqa/shared';
import type { TestListItemDto } from '@flowqa/shared';

const filterTestDailyHistoryByStatuses = (
  dailyHistory: TestDailyStatusDto[] | undefined,
  selectedStatuses: Array<NonNullable<TestDailyStatusDto['status']>>,
): TestDailyStatusDto[] => {
  if (selectedStatuses.length === 0) {
    return dailyHistory ?? [];
  }

  const selectedStatusSet = new Set(selectedStatuses);

  return (dailyHistory ?? []).map((historyDay) => {
    const details = historyDay.details.filter((detail) => selectedStatusSet.has(detail.status));
    const statuses = details.map((detail) => detail.status);

    return {
      ...historyDay,
      status: statuses[0] ?? null,
      statuses,
      details,
    };
  });
};

export const buildTestHistoryRows = (
  tests: TestListItemDto[] | undefined,
  selectedStatuses: Array<NonNullable<TestDailyStatusDto['status']>> = [],
  options?: { preferFileNameOverDisplayName?: boolean },
): EntityDailyHistoryRow[] =>
  (tests ?? []).map((test) => {
    const primarySuite = test.suites?.primary ?? test.suites?.items?.[0] ?? null;
    const prefixLabel = primarySuite ? resolveSuiteEntityDisplayName(primarySuite, options) : null;
    const prefixHref = buildSuiteDetailPath(primarySuite?.slug ?? primarySuite?.id);

    return attachRowDailyHistoryRunLinks(
      {
        id: test.id,
        prefixLabel,
        prefixHref,
        name: resolveTestEntityDisplayName(test, options),
        href: `/tests/${test.slug}`,
        dailyHistory: filterTestDailyHistoryByStatuses(test.dailyHistory, selectedStatuses),
      },
      'test',
    );
  });
